export const DEFAULT_LANGUAGE = 'bg';
export const FALLBACK_LANGUAGE = 'en';

// Keep the language picker list here so UI and translations stay in sync.
export const LANGUAGES = [
  { code: 'bg', name: 'Български', flag: '🇧🇬' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
];

// NOTE:
// - We fully translate bg/en/de.
// - For other languages we currently fall back to English to avoid mixed BG/EN UI.
export const TRANSLATIONS = {
  bg: {
    // Navigation
    home: 'Начало',
    clients: 'Клиенти',
    orders: 'Работна карта',
    worktimes: 'Нормовремена',
    vehicles: 'Превозни средства',
    invoices: 'ФАКТУРИ',
    admin: 'Администриране',

    // Settings / UI
    lightMode: 'Светъл режим',
    darkMode: 'Тъмен режим',
    language: 'Език',
    personalization: 'Персонализация',
    logout: 'Изход',
    close: 'Затвори',
    cancel: 'Отказ',
    save: 'Запази',
    confirm: 'Потвърди',

    personalizationTitle: 'Персонализация на интерфейса',
    primaryColor: 'Основен цвят',
    color: 'Цвят',
    chooseAccentColorHelp: 'Изберете предпочитания цвят за акцентите в интерфейса',
    appbarGradient: 'Градиент (лента)',
    gradientHelpLight: 'Градиентът започва от бяло и завършва с избрания цвят.',
    gradientHelpDark: 'Градиентът започва от черно и завършва с избрания цвят.',

    // Home page
    welcome: 'Добре дошли в системата за управление на сервиз!',
    user: 'Потребител',
    homeClientsDesc: 'Управление на клиентската база данни',
    homeOrdersDesc: 'Активни поръчки и сервизна дейност',
    homeWorktimesDesc: 'Стандартни норми за ремонтни дейности',
    homeVehiclesDesc: 'Търсене и управление на автомобили и ремаркета',
    homeInvoicesDesc: 'Приключени поръчки и корекции преди фактуриране',

    // Module titles / common labels
    clientsTitle: 'Клиенти',
    ordersTitle: 'Работна карта',
    worktimesTitle: 'Нормовремена',
    vehiclesTitle: 'Превозни средства',
    invoicesTitle: 'Фактури',
    adminTitle: 'Администриране',

    // Common actions
    search: 'Търсене',
    show: 'Покажи',
    hide: 'Скрий',
    details: 'Детайли',
    delete: 'Изтрий',
    edit: 'Редакция',

    // Auth / public pages
    authWorkshop: 'Сервиз',
    authSystem: 'Система за управление',
    login: 'Вход',
    loginTitle: 'Вход в системата',
    register: 'Регистрация',
    registerTitle: 'Регистрация',
    nickname: 'Никнейм',
    firstName: 'Име',
    lastName: 'Фамилия',
    email: 'Имейл',
    password: 'Парола',
    confirmPassword: 'Потвърди парола',
    alreadyHaveAccount: 'Вече имате акаунт? Влезте',
    noAccountRegister: 'Нямате акаунт? Регистрирайте се',
    forgotPassword: 'Забравихте паролата?',

    // Common error/success (public)
    serverError: 'Грешка към сървъра!',
    invalidRegistrationLink: 'Невалиден линк за регистрация. Обърнете се към администратора.',
    loginError: 'Грешка при вход!',
    registrationError: 'Грешка при регистрация!',
    registrationSuccess: 'Регистрация успешна! Влезте с вашия никнейм и парола.',
    pleaseEnterNickname: 'Моля въведете никнейм!',
    pleaseEnterEmail: 'Моля въведете имейл!',
    pleaseEnterFirstName: 'Моля въведете име!',
    pleaseEnterLastName: 'Моля въведете фамилия!',
    pleaseEnterValidEmail: 'Моля въведете валиден имейл адрес!',
    passwordMin6: 'Паролата трябва да бъде поне 6 символа!',
    passwordsDontMatch: 'Паролите не съвпадат!',

    backToLogin: 'Обратно към вход',
    forgotPasswordTitle: 'Възстановяване на парола',
    forgotPasswordSubtitle: 'Въведете имейл адреса, който сте използвали при регистрация',
    emailAddress: 'Имейл адрес',
    sendResetLink: 'Изпрати линк за възстановяване',
    sending: 'Изпращане...',
    resetRequestError: 'Възникна грешка при изпращане на заявката',
    resetRequestSuccess: 'Ако имейлът съществува в системата, ще получите линк за възстановяване на парола',
    resetRequestInfo: 'Ще получите имейл с инструкции за възстановяване на паролата, ако този имейл е регистриран в системата.',

    // Reset password page
    invalidResetLink: 'Невалиден линк за възстановяване',
    invalidOrExpiredToken: 'Невалиден или изтекъл токен',
    tokenVerificationError: 'Грешка при проверка на токена',
    fillAllFields: 'Моля попълнете всички полета',
    passwordsDontMatchNoBang: 'Паролите не съвпадат',
    passwordMin6NoBang: 'Паролата трябва да бъде поне 6 символа',
    resetPasswordError: 'Грешка при възстановяване на паролата',
    resetPasswordSuccess: 'Паролата е възстановена успешно!',
    verifyingLink: 'Проверка на линка...',
    done: 'Готово!',
    passwordResetDone: 'Паролата ви е възстановена успешно.',
    redirectingToLogin: 'Пренасочване към страницата за вход...',
    newPasswordTitle: 'Нова парола',
    hello: 'Здравейте',
    newPassword: 'Нова парола',
    confirmNewPassword: 'Потвърди нова парола',
    min6Chars: 'Минимум 6 символа',
    saving: 'Запазване...',
    saveNewPassword: 'Запази новата парола',
    resetLinkInvalidOrExpired: 'Този линк за възстановяване е невалиден или е изтекъл.',
    requestNewResetLink: 'Моля поискайте нов линк за възстановяване.',
    resetLinkValidFor1h: 'Линкът е валиден само за 1 час от получаването на имейла.',

    // Vehicles module
    vehiclesSearch: 'Търсене',
    generalSearch: 'Общо търсене',
    generalSearchPlaceholder: 'Рег.номер, VIN, собственик...',
    detailedSearch: 'Подробно търсене',
    showDetailedSearch: 'Показвай подробно търсене',
    hideDetailedSearch: 'Скрий подробно търсене',
    brand: 'Марка',
    model: 'Модел',
    vehicleType: 'Тип превозно средство',
    all: 'Всички',
    truck: 'Камион',
    trailer: 'Ремарке',
    results: 'Резултати',
    showItems: 'Покажи:',
    vehicle: 'Превозно средство',
    regNumberShort: 'Рег. номер',
    vin: 'VIN',
    owner: 'Собственик',
    actions: 'Действия',
    history: 'История',
    none: 'Няма',
    noVehiclesFound: 'Няма намерени превозни средства',
    serviceHistory: 'Сервизна история',
    noServiceHistory: 'Няма сервизна история за това превозно средство',
    statusActive: 'Активна',
    statusCompleted: 'Завършена',
    repairDetails: 'Детайли ремонт',
    repairDetailsOps: 'Детайли (операции)',
    client: 'Клиент',
    date: 'Дата',
    complaintLabel: 'Оплакване',
    loadingOperations: 'Зареждане на операции...',
    noOperations: 'Няма добавени операции за тази поръчка.',
    operation: 'Операция',
    component: 'Компонент',
    hoursLabel: 'Часове',
    quantityShort: 'К-во',
    total: 'Общо',
    notes: 'Бележки',

    // Clients module (existing keys used in pages)
    searchClients: 'Търси клиенти по име или телефон...',
    createClient: 'Създай нов клиент',
    companyName: 'Име на фирма',
    address: 'Адрес',
    eik: 'ЕИК',
    phone: 'Телефон',
    createClientBtn: 'Създай клиент',

    // Orders (Workorder / Work Card) module
    createOrder: 'Създай нова поръчка',
    clientName: 'Име на клиент',
    regNumber: 'Регистрационен номер',
    complaint: 'Оплакване',
    createOrderBtn: 'Създай поръчка',
    activeOrders: 'Активни поръчки',

    // Worktimes module
    addWorktime: 'Добави нормовреме',
    worktimeTitle: 'Наименование на дейността',
    hours: 'Нормовреме (часове)',
    addWorktimeBtn: 'Добави нормовреме',
    standardWorktimes: 'Стандартни нормовремена',
    componentFieldLabel: 'Компонент',
    worktimeActivityLabel: 'Наименование на дейността',
    worktimeHoursLabel: 'Нормовреме (часове)',
    worktimeDescription: 'Стандартно време за изпълнение на дейността',
    noWorktimesSelectedComponent: 'Няма нормовремена за избрания компонент',
    addFirstWorktimeForComponent: 'Добавете първото нормовреме за този компонент',
    hoursShortSuffix: 'ч.',
    worktimeComponentCabin: 'Кабина',
    worktimeComponentChassis: 'Шаси',
    worktimeComponentFrontAxle: 'Преден мост',
    worktimeComponentRearAxle: 'Заден мост',
    worktimeComponentEngine: 'Двигател',
    worktimeComponentTransmission: 'Скоростна кутия',

    // Clients module extra
    clientsList: 'Списък с клиенти',
    trucksLabel: 'Камиони',
    trailersLabel: 'Ремаркета',
    more: 'още',
    editClientTitle: 'Редакция на клиент',
    addVehicleToClient: 'Добави превозно средство към',
    addVehicle: 'Добави превозно средство',
    deleteClientConfirm: 'Сигурни ли сте, че искате да изтриете този клиент?',
    deleteClientError: 'Грешка при изтриване на клиента',
    editClientError: 'Грешка при редакция на клиента',
    noClientsFound: 'Няма намерени клиенти',
    addFirstClientOrChangeSearch: 'Добавете първия клиент или променете търсенето',
    city: 'Град',
    vatNumber: 'ДДС №',
    mol: 'МОЛ',
    vehiclesOfClient: 'Превозни средства на',
    noRegisteredVehicles: 'Няма регистрирани превозни средства',
    requiredFieldsVehicle: 'Моля попълнете задължителните полета: Рег. номер, Марка, Модел',
    addVehicleError: 'Грешка при добавяне на превозно средство',
    regNumberRequired: 'Регистрационен номер *',
    vinNumber: 'VIN номер',
    brandRequired: 'Марка *',
    modelRequired: 'Модел *',
    vehicleTypeRequired: 'Тип превозно средство *',
    yearLabel: 'Година',
    gearBox: 'Скоростна кутия',
    gearBoxPlaceholder: 'Например: PowerShift, TipMatic',
    axesCount: 'Брой оси',
    axesPlaceholder: 'Например: 2 или 3',

    // Admin module
    adminUsersHeading: 'Администриране на потребители',
    adminInfoText: 'Тук можете да управлявате потребителите, техните роли и разрешения за достъп до различните модули на системата.',
    invoiceSettingsHeading: 'Настройки за фактуриране (Доставчик)',
    invoiceSettingsHint: 'Тези данни се използват при принтиране на Протокол/Фактура в таба „ФАКТУРИ“.',
    brandingSection: 'Брандинг (горна лента)',
    appNameInBar: 'Име на приложението (в лентата)',
    loginTaglineLine1: 'Слоган (ред 1) (Login/Register)',
    loginTaglineLine2: 'Слоган (ред 2) (Login/Register)',
    loginTaglineHelp: 'Оставете празно, за да се използва стандартният слоган на страницата за вход.',
    fontInBar: 'Шрифт (в лентата)',
    fontSizeInBar: 'Размер (в лентата)',
    sizeSmall: 'Малък',
    sizeMedium: 'Среден',
    sizeLarge: 'Голям',
    sizeVeryLarge: 'Много голям',
    showBrandingLoginRegister: 'Покажи брандинг и на Login/Register',
    loginGradient: 'Градиент (Login/Register)',
    paymentMethod: 'Начин на плащане',
    bank: 'Банка',
    hourlyRate: 'Цена на час',
    vatRate: 'ДДС',
    invoiceNumbering: 'Номерация (Протокол / Фактура)',
    invoiceNumberingHint: 'Въведете последно издадените номера. При генериране на нов документ системата ще взима следващия номер (+1).',
    invoicePrefix: 'Префикс на фактура',
    invoiceLength: 'Дължина (фактура)',
    invoiceLastNo: 'Последен № (фактура)',
    protocolLength: 'Дължина (протокол)',
    protocolLastNo: 'Последен № (протокол)',
    logoForDocs: 'Лого (за Протокол/Фактура)',
    chooseFile: 'Избери файл',
    remove: 'Премахни',
    logoRecommendation: 'Препоръка: квадратен PNG, прозрачен фон.',
    noLogoUploaded: 'Няма качено лого.',
    saveSettings: 'Запази настройки',
    usersRegistered: 'Регистрирани потребители',
    userCol: 'Потребител',
    roleCol: 'Роля',
    statusCol: 'Статус',
    registeredCol: 'Регистриран',
    lastLoginCol: 'Последно влизане',
    permissionsCol: 'Разрешения',
    actionsCol: 'Действия',
    roleUser: 'Потребител',
    roleAdmin: 'Администратор',
    active: 'Активен',
    inactive: 'Неактивен',
    never: 'Никога',
    modulesCount: 'модула',
    noUsers: 'Няма регистрирани потребители',
    loadUsersError: 'Грешка при зареждане на потребителите',
    saveCompanySettingsError: 'Грешка при запазване на фирмените настройки',
    savePermissionsError: 'Грешка при запазване на разрешенията',
    changeRoleError: 'Грешка при промяна на ролята',
    changeStatusError: 'Грешка при промяна на статуса',
    deleteUserConfirm: 'Сигурни ли сте, че искате да изтриете потребителя',
    userDeleted: 'Потребителят е изтрит успешно',
    deleteUserError: 'Грешка при изтриване на потребителя',
    fileTooLarge: 'Файлът е твърде голям. Моля изберете лого до ~600KB (PNG/JPG).',
    fileReadError: 'Грешка при прочитане на файла.',

    invitationsManage: 'Управление на покани',
    createInvitation: 'Създай покана',
    token: 'Токен',
    createdBy: 'Създадена от',
    status: 'Статус',
    createdAt: 'Създадена',
    expiresAt: 'Изтича',
    used: 'Използвана',
    activeInvitation: 'Активна',
    noInvitations: 'Няма създадени покани',
    invitationEmailRequired: 'Моля въведете имейл адрес',
    invitationErrorPrefix: 'Грешка при създаване на покана: ',
    deleteInvitationConfirm: 'Сигурни ли сте, че искате да изтриете тази покана?',
    deleteInvitationError: 'Грешка при изтриване на поканата',
    linkCopied: 'Линкът е копиран в клипборда',
    newInvitationTitle: 'Нова покана за регистрация',
    copyInvitationHint: 'Копирайте този линк и го изпратете на потребителя, който искате да се регистрира:',
    linkValidUntil: 'Линкът е валиден до:',
    copyLink: 'Копирай линка',

    permissionsManage: 'Управление на разрешения',
    permissionsHelp: 'Определете кои действия може да извършва този потребител във всеки модул на системата.',
    moduleAccess: 'Достъп до модула:',
    read: 'Четене',
    write: 'Писане',
    deleteAction: 'Изтриване',
    savePermissions: 'Запази разрешения',

    // Parts / Consumables module
    parts: 'Части и консумативи',
    partsTitle: 'Части и консумативи',
    homePartsDesc: 'Складова наличност на части и консумативи',
    partsSearch: 'Търсене на части',
    partsSearchPlaceholder: 'Име, артикул, категория...',
    allCategories: 'Всички категории',
    lowStockOnly: 'Само нисък запас',
    partName: 'Наименование',
    sku: 'Артикул (код)',
    category: 'Категория',
    unit: 'Мерна единица',
    quantity: 'Наличност',
    minQuantity: 'Мин. наличност',
    price: 'Цена',
    location: 'Място',
    addPart: 'Добави част',
    editPart: 'Редакция на част',
    partNameRequired: 'Моля въведете наименование',
    adjustStock: 'Складова операция',
    stockIn: 'Приход',
    stockOut: 'Разход',
    movementHistory: 'История на движенията',
    movementType: 'Тип операция',
    movementQuantity: 'Количество',
    movementDate: 'Дата',
    movementBy: 'От',
    supplier: 'Доставчик',
    currentStock: 'Текуща наличност',
    quantityPositive: 'Количеството трябва да е положително число',
    noPartsFound: 'Няма намерени части',
    noMovements: 'Няма движения за тази част',
    inStock: 'В наличност',
    lowStock: 'Нисък запас',
    outOfStock: 'Няма наличност',
    deletePartConfirm: 'Сигурни ли сте, че искате да изтриете тази част?',
    quantityEditHint: 'Наличността се променя само чрез складова операция (приход/разход).',
    partsLoadError: 'Грешка при зареждане на частите',
    partsSaveError: 'Грешка при запазване на частта',
    partsDeleteError: 'Грешка при изтриване на частта',
    partsAdjustError: 'Грешка при складовата операция',
    loading: 'Зареждане...',

  },
  en: {
    home: 'Home',
    clients: 'Clients',
    orders: 'Work Card',
    worktimes: 'Work Times',
    vehicles: 'Vehicles',
    invoices: 'INVOICES',
    admin: 'Administration',

    lightMode: 'Light mode',
    darkMode: 'Dark mode',
    language: 'Language',
    personalization: 'Personalization',
    logout: 'Logout',
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    confirm: 'Confirm',

    personalizationTitle: 'Interface personalization',
    primaryColor: 'Primary color',
    color: 'Color',
    chooseAccentColorHelp: 'Choose your preferred accent color for the interface',
    appbarGradient: 'Gradient (top bar)',
    gradientHelpLight: 'The gradient starts from white and ends with the selected color.',
    gradientHelpDark: 'The gradient starts from black and ends with the selected color.',

    welcome: 'Welcome to the service management system!',
    user: 'User',
    homeClientsDesc: 'Manage your customer database',
    homeOrdersDesc: 'Active orders and workshop operations',
    homeWorktimesDesc: 'Standard norms for repair activities',
    homeVehiclesDesc: 'Search and manage trucks and trailers',
    homeInvoicesDesc: 'Completed orders and adjustments before invoicing',

    clientsTitle: 'Clients',
    ordersTitle: 'Work Card',
    worktimesTitle: 'Work Times',
    vehiclesTitle: 'Vehicles',
    invoicesTitle: 'Invoices',
    adminTitle: 'Administration',

    search: 'Search',
    show: 'Show',
    hide: 'Hide',
    details: 'Details',
    delete: 'Delete',
    edit: 'Edit',

    authWorkshop: 'Workshop',
    authSystem: 'Management system',
    login: 'Login',
    loginTitle: 'Sign in',
    register: 'Register',
    registerTitle: 'Create account',
    nickname: 'Nickname',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    alreadyHaveAccount: 'Already have an account? Sign in',
    noAccountRegister: "Don't have an account? Register",
    forgotPassword: 'Forgot your password?',

    serverError: 'Server error!',
    invalidRegistrationLink: 'Invalid registration link. Please contact the administrator.',
    loginError: 'Login error!',
    registrationError: 'Registration error!',
    registrationSuccess: 'Registration successful! Sign in with your nickname and password.',
    pleaseEnterNickname: 'Please enter a nickname!',
    pleaseEnterEmail: 'Please enter an email!',
    pleaseEnterFirstName: 'Please enter a first name!',
    pleaseEnterLastName: 'Please enter a last name!',
    pleaseEnterValidEmail: 'Please enter a valid email address!',
    passwordMin6: 'Password must be at least 6 characters!',
    passwordsDontMatch: "Passwords don't match!",

    backToLogin: 'Back to login',
    forgotPasswordTitle: 'Password recovery',
    forgotPasswordSubtitle: 'Enter the email address you used when registering',
    emailAddress: 'Email address',
    sendResetLink: 'Send password reset link',
    sending: 'Sending...',
    resetRequestError: 'An error occurred while sending the request',
    resetRequestSuccess: "If the email exists in the system, you'll receive a password reset link",
    resetRequestInfo: "You'll receive an email with instructions if this email is registered in the system.",

    invalidResetLink: 'Invalid recovery link',
    invalidOrExpiredToken: 'Invalid or expired token',
    tokenVerificationError: 'Error verifying token',
    fillAllFields: 'Please fill in all fields',
    passwordsDontMatchNoBang: "Passwords don't match",
    passwordMin6NoBang: 'Password must be at least 6 characters',
    resetPasswordError: 'Error resetting password',
    resetPasswordSuccess: 'Password reset successful!',
    verifyingLink: 'Verifying link...',
    done: 'Done!',
    passwordResetDone: 'Your password has been reset successfully.',
    redirectingToLogin: 'Redirecting to login...',
    newPasswordTitle: 'New password',
    hello: 'Hello',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    min6Chars: 'Minimum 6 characters',
    saving: 'Saving...',
    saveNewPassword: 'Save new password',
    resetLinkInvalidOrExpired: 'This password reset link is invalid or has expired.',
    requestNewResetLink: 'Please request a new reset link.',
    resetLinkValidFor1h: 'The link is valid for 1 hour from the time the email was received.',

    vehiclesSearch: 'Search',
    generalSearch: 'General search',
    generalSearchPlaceholder: 'Plate, VIN, owner...',
    detailedSearch: 'Detailed search',
    showDetailedSearch: 'Show detailed search',
    hideDetailedSearch: 'Hide detailed search',
    brand: 'Brand',
    model: 'Model',
    vehicleType: 'Vehicle type',
    all: 'All',
    truck: 'Truck',
    trailer: 'Trailer',
    results: 'Results',
    showItems: 'Show:',
    vehicle: 'Vehicle',
    regNumberShort: 'Plate',
    vin: 'VIN',
    owner: 'Owner',
    actions: 'Actions',
    history: 'History',
    none: 'N/A',
    noVehiclesFound: 'No vehicles found',
    serviceHistory: 'Service history',
    noServiceHistory: 'No service history for this vehicle',
    statusActive: 'Active',
    statusCompleted: 'Completed',
    repairDetails: 'Repair details',
    repairDetailsOps: 'Details (operations)',
    client: 'Client',
    date: 'Date',
    complaintLabel: 'Complaint',
    loadingOperations: 'Loading operations...',
    noOperations: 'No operations added for this order.',
    operation: 'Operation',
    component: 'Component',
    hoursLabel: 'Hours',
    quantityShort: 'Qty',
    total: 'Total',
    notes: 'Notes',

    searchClients: 'Search clients by name or phone...',
    createClient: 'Create new client',
    companyName: 'Company name',
    address: 'Address',
    eik: 'EIK',
    phone: 'Phone',
    createClientBtn: 'Create client',

    createOrder: 'Create new order',
    clientName: 'Client name',
    regNumber: 'Registration number',
    complaint: 'Complaint',
    createOrderBtn: 'Create order',
    activeOrders: 'Active orders',

    addWorktime: 'Add work time',
    worktimeTitle: 'Activity name',
    hours: 'Work time (hours)',
    addWorktimeBtn: 'Add work time',
    standardWorktimes: 'Standard work times',
    componentFieldLabel: 'Component',
    worktimeActivityLabel: 'Activity name',
    worktimeHoursLabel: 'Work time (hours)',
    worktimeDescription: 'Standard time to complete the activity',
    noWorktimesSelectedComponent: 'No work times for the selected component',
    addFirstWorktimeForComponent: 'Add the first work time for this component',
    hoursShortSuffix: 'h',
    worktimeComponentCabin: 'Cabin',
    worktimeComponentChassis: 'Chassis',
    worktimeComponentFrontAxle: 'Front axle',
    worktimeComponentRearAxle: 'Rear axle',
    worktimeComponentEngine: 'Engine',
    worktimeComponentTransmission: 'Transmission',

    clientsList: 'Clients list',
    trucksLabel: 'Trucks',
    trailersLabel: 'Trailers',
    more: 'more',
    editClientTitle: 'Edit client',
    addVehicleToClient: 'Add vehicle to',
    addVehicle: 'Add vehicle',
    deleteClientConfirm: 'Are you sure you want to delete this client?',
    deleteClientError: 'Error deleting the client',
    editClientError: 'Error editing the client',
    noClientsFound: 'No clients found',
    addFirstClientOrChangeSearch: 'Add your first client or change the search',
    city: 'City',
    vatNumber: 'VAT No.',
    mol: 'Manager',
    vehiclesOfClient: 'Vehicles of',
    noRegisteredVehicles: 'No registered vehicles',
    requiredFieldsVehicle: 'Please fill the required fields: Plate, Brand, Model',
    addVehicleError: 'Error adding vehicle',
    regNumberRequired: 'Registration number *',
    vinNumber: 'VIN number',
    brandRequired: 'Brand *',
    modelRequired: 'Model *',
    vehicleTypeRequired: 'Vehicle type *',
    yearLabel: 'Year',
    gearBox: 'Gearbox',
    gearBoxPlaceholder: 'e.g. PowerShift, TipMatic',
    axesCount: 'Number of axles',
    axesPlaceholder: 'e.g. 2 or 3',

    adminUsersHeading: 'User administration',
    adminInfoText: 'Manage users, their roles, and access permissions for the different modules.',
    invoiceSettingsHeading: 'Invoicing settings (Supplier)',
    invoiceSettingsHint: 'These details are used when printing Protocol/Invoice in the “INVOICES” tab.',
    brandingSection: 'Branding (top bar)',
    appNameInBar: 'Application name (in bar)',
    loginTaglineLine1: 'Tagline (line 1) (Login/Register)',
    loginTaglineLine2: 'Tagline (line 2) (Login/Register)',
    loginTaglineHelp: 'Leave blank to use the default tagline on the login page.',
    fontInBar: 'Font (in bar)',
    fontSizeInBar: 'Size (in bar)',
    sizeSmall: 'Small',
    sizeMedium: 'Medium',
    sizeLarge: 'Large',
    sizeVeryLarge: 'Very large',
    showBrandingLoginRegister: 'Show branding on Login/Register',
    loginGradient: 'Gradient (Login/Register)',
    paymentMethod: 'Payment method',
    bank: 'Bank',
    hourlyRate: 'Hourly rate',
    vatRate: 'VAT',
    invoiceNumbering: 'Numbering (Protocol / Invoice)',
    invoiceNumberingHint: 'Enter the last issued numbers. The system will use the next number (+1) when generating a new document.',
    invoicePrefix: 'Invoice prefix',
    invoiceLength: 'Length (invoice)',
    invoiceLastNo: 'Last No. (invoice)',
    protocolLength: 'Length (protocol)',
    protocolLastNo: 'Last No. (protocol)',
    logoForDocs: 'Logo (Protocol/Invoice)',
    chooseFile: 'Choose file',
    remove: 'Remove',
    logoRecommendation: 'Recommendation: square PNG, transparent background.',
    noLogoUploaded: 'No logo uploaded.',
    saveSettings: 'Save settings',
    usersRegistered: 'Registered users',
    userCol: 'User',
    roleCol: 'Role',
    statusCol: 'Status',
    registeredCol: 'Registered',
    lastLoginCol: 'Last login',
    permissionsCol: 'Permissions',
    actionsCol: 'Actions',
    roleUser: 'User',
    roleAdmin: 'Admin',
    active: 'Active',
    inactive: 'Inactive',
    never: 'Never',
    modulesCount: 'modules',
    noUsers: 'No registered users',
    loadUsersError: 'Error loading users',
    saveCompanySettingsError: 'Error saving company settings',
    savePermissionsError: 'Error saving permissions',
    changeRoleError: 'Error changing role',
    changeStatusError: 'Error changing status',
    deleteUserConfirm: 'Are you sure you want to delete the user',
    userDeleted: 'User deleted successfully',
    deleteUserError: 'Error deleting user',
    fileTooLarge: 'File is too large. Please choose a logo up to ~600KB (PNG/JPG).',
    fileReadError: 'Error reading the file.',

    invitationsManage: 'Invitations',
    createInvitation: 'Create invitation',
    token: 'Token',
    createdBy: 'Created by',
    status: 'Status',
    createdAt: 'Created',
    expiresAt: 'Expires',
    used: 'Used',
    activeInvitation: 'Active',
    noInvitations: 'No invitations created',
    invitationEmailRequired: 'Please enter an email address',
    invitationErrorPrefix: 'Error creating invitation: ',
    deleteInvitationConfirm: 'Are you sure you want to delete this invitation?',
    deleteInvitationError: 'Error deleting invitation',
    linkCopied: 'Link copied to clipboard',
    newInvitationTitle: 'New registration invitation',
    copyInvitationHint: 'Copy this link and send it to the user you want to register:',
    linkValidUntil: 'Link valid until:',
    copyLink: 'Copy link',

    permissionsManage: 'Permissions',
    permissionsHelp: 'Select which actions this user can perform in each module.',
    moduleAccess: 'Module access:',
    read: 'Read',
    write: 'Write',
    deleteAction: 'Delete',
    savePermissions: 'Save permissions',

    // Parts / Consumables module
    parts: 'Parts & Consumables',
    partsTitle: 'Parts & Consumables',
    homePartsDesc: 'Warehouse stock of parts and consumables',
    partsSearch: 'Search parts',
    partsSearchPlaceholder: 'Name, SKU, category...',
    allCategories: 'All categories',
    lowStockOnly: 'Only low stock',
    partName: 'Name',
    sku: 'SKU',
    category: 'Category',
    unit: 'Unit',
    quantity: 'Stock',
    minQuantity: 'Min. stock',
    price: 'Price',
    location: 'Location',
    addPart: 'Add part',
    editPart: 'Edit part',
    partNameRequired: 'Please enter a name',
    adjustStock: 'Stock adjustment',
    stockIn: 'Receive',
    stockOut: 'Issue',
    movementHistory: 'Movement history',
    movementType: 'Operation type',
    movementQuantity: 'Quantity',
    movementDate: 'Date',
    movementBy: 'By',
    supplier: 'Supplier',
    currentStock: 'Current stock',
    quantityPositive: 'Quantity must be a positive number',
    noPartsFound: 'No parts found',
    noMovements: 'No movements for this part',
    inStock: 'In stock',
    lowStock: 'Low stock',
    outOfStock: 'Out of stock',
    deletePartConfirm: 'Are you sure you want to delete this part?',
    quantityEditHint: 'Stock can only be changed via a stock adjustment (receive/issue).',
    partsLoadError: 'Error loading parts',
    partsSaveError: 'Error saving the part',
    partsDeleteError: 'Error deleting the part',
    partsAdjustError: 'Error during stock adjustment',
    loading: 'Loading...',

  },
  de: {
    home: 'Startseite',
    clients: 'Kunden',
    orders: 'Arbeitskarte',
    worktimes: 'Arbeitszeiten',
    vehicles: 'Fahrzeuge',
    invoices: 'RECHNUNGEN',
    admin: 'Administration',

    lightMode: 'Hellmodus',
    darkMode: 'Dunkelmodus',
    language: 'Sprache',
    personalization: 'Personalisierung',
    logout: 'Abmelden',
    close: 'Schließen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    confirm: 'Bestätigen',

    personalizationTitle: 'Oberfläche personalisieren',
    primaryColor: 'Primärfarbe',
    color: 'Farbe',
    chooseAccentColorHelp: 'Wählen Sie Ihre bevorzugte Akzentfarbe',
    appbarGradient: 'Verlauf (obere Leiste)',
    gradientHelpLight: 'Der Verlauf beginnt bei Weiß und endet mit der ausgewählten Farbe.',
    gradientHelpDark: 'Der Verlauf beginnt bei Schwarz und endet mit der ausgewählten Farbe.',

    welcome: 'Willkommen im Service-Management-System!',
    user: 'Benutzer',
    homeClientsDesc: 'Verwaltung der Kundendatenbank',
    homeOrdersDesc: 'Aktive Aufträge und Werkstattbetrieb',
    homeWorktimesDesc: 'Standardzeiten für Reparaturarbeiten',
    homeVehiclesDesc: 'Suche und Verwaltung von Fahrzeugen',
    homeInvoicesDesc: 'Abgeschlossene Aufträge und Anpassungen vor der Rechnungsstellung',

    clientsTitle: 'Kunden',
    ordersTitle: 'Arbeitskarte',
    worktimesTitle: 'Arbeitszeiten',
    vehiclesTitle: 'Fahrzeuge',
    invoicesTitle: 'Rechnungen',
    adminTitle: 'Administration',

    search: 'Suche',
    show: 'Anzeigen',
    hide: 'Ausblenden',
    details: 'Details',
    delete: 'Löschen',
    edit: 'Bearbeiten',

    authWorkshop: 'Werkstatt',
    authSystem: 'Verwaltungssystem',
    login: 'Anmelden',
    loginTitle: 'Anmeldung',
    register: 'Registrieren',
    registerTitle: 'Registrierung',
    nickname: 'Benutzername',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    alreadyHaveAccount: 'Sie haben bereits ein Konto? Anmelden',
    noAccountRegister: 'Noch kein Konto? Registrieren',
    forgotPassword: 'Passwort vergessen?',

    serverError: 'Serverfehler!',
    invalidRegistrationLink: 'Ungültiger Registrierungslink. Bitte wenden Sie sich an den Administrator.',
    loginError: 'Fehler bei der Anmeldung!',
    registrationError: 'Fehler bei der Registrierung!',
    registrationSuccess: 'Registrierung erfolgreich! Melden Sie sich mit Benutzername und Passwort an.',
    pleaseEnterNickname: 'Bitte Benutzername eingeben!',
    pleaseEnterEmail: 'Bitte E-Mail eingeben!',
    pleaseEnterFirstName: 'Bitte Vorname eingeben!',
    pleaseEnterLastName: 'Bitte Nachname eingeben!',
    pleaseEnterValidEmail: 'Bitte eine gültige E-Mail-Adresse eingeben!',
    passwordMin6: 'Das Passwort muss mindestens 6 Zeichen lang sein!',
    passwordsDontMatch: 'Passwörter stimmen nicht überein!',

    backToLogin: 'Zurück zur Anmeldung',
    forgotPasswordTitle: 'Passwort zurücksetzen',
    forgotPasswordSubtitle: 'Geben Sie die E-Mail-Adresse ein, die Sie bei der Registrierung verwendet haben',
    emailAddress: 'E-Mail-Adresse',
    sendResetLink: 'Link zum Zurücksetzen senden',
    sending: 'Senden...',
    resetRequestError: 'Fehler beim Senden der Anfrage',
    resetRequestSuccess: 'Wenn die E-Mail im System existiert, erhalten Sie einen Link zum Zurücksetzen des Passworts',
    resetRequestInfo: 'Sie erhalten eine E-Mail mit Anweisungen, wenn diese E-Mail im System registriert ist.',

    invalidResetLink: 'Ungültiger Wiederherstellungslink',
    invalidOrExpiredToken: 'Ungültiger oder abgelaufener Token',
    tokenVerificationError: 'Fehler bei der Token-Prüfung',
    fillAllFields: 'Bitte füllen Sie alle Felder aus',
    passwordsDontMatchNoBang: 'Passwörter stimmen nicht überein',
    passwordMin6NoBang: 'Das Passwort muss mindestens 6 Zeichen lang sein',
    resetPasswordError: 'Fehler beim Zurücksetzen des Passworts',
    resetPasswordSuccess: 'Passwort erfolgreich zurückgesetzt!',
    verifyingLink: 'Link wird geprüft...',
    done: 'Fertig!',
    passwordResetDone: 'Ihr Passwort wurde erfolgreich zurückgesetzt.',
    redirectingToLogin: 'Weiterleitung zur Anmeldung...',
    newPasswordTitle: 'Neues Passwort',
    hello: 'Hallo',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    min6Chars: 'Mindestens 6 Zeichen',
    saving: 'Speichern...',
    saveNewPassword: 'Neues Passwort speichern',
    resetLinkInvalidOrExpired: 'Dieser Link zum Zurücksetzen ist ungültig oder abgelaufen.',
    requestNewResetLink: 'Bitte fordern Sie einen neuen Link an.',
    resetLinkValidFor1h: 'Der Link ist 1 Stunde ab Erhalt der E-Mail gültig.',

    vehiclesSearch: 'Suche',
    generalSearch: 'Allgemeine Suche',
    generalSearchPlaceholder: 'Kennzeichen, VIN, Besitzer...',
    detailedSearch: 'Detaillierte Suche',
    showDetailedSearch: 'Detaillierte Suche anzeigen',
    hideDetailedSearch: 'Detaillierte Suche ausblenden',
    brand: 'Marke',
    model: 'Modell',
    vehicleType: 'Fahrzeugtyp',
    all: 'Alle',
    truck: 'LKW',
    trailer: 'Anhänger',
    results: 'Ergebnisse',
    showItems: 'Anzeigen:',
    vehicle: 'Fahrzeug',
    regNumberShort: 'Kennzeichen',
    vin: 'VIN',
    owner: 'Besitzer',
    actions: 'Aktionen',
    history: 'Historie',
    none: '—',
    noVehiclesFound: 'Keine Fahrzeuge gefunden',
    serviceHistory: 'Servicehistorie',
    noServiceHistory: 'Keine Servicehistorie für dieses Fahrzeug',
    statusActive: 'Aktiv',
    statusCompleted: 'Abgeschlossen',
    repairDetails: 'Reparaturdetails',
    repairDetailsOps: 'Details (Arbeiten)',
    client: 'Kunde',
    date: 'Datum',
    complaintLabel: 'Beanstandung',
    loadingOperations: 'Lade Arbeiten...',
    noOperations: 'Keine Arbeiten für diesen Auftrag.',
    operation: 'Arbeit',
    component: 'Komponente',
    hoursLabel: 'Stunden',
    quantityShort: 'Menge',
    total: 'Gesamt',
    notes: 'Notizen',

    searchClients: 'Kunden nach Name oder Telefon suchen...',
    createClient: 'Neuen Kunden erstellen',
    companyName: 'Firmenname',
    address: 'Adresse',
    eik: 'EIK',
    phone: 'Telefon',
    createClientBtn: 'Kunden erstellen',

    createOrder: 'Neue Bestellung erstellen',
    clientName: 'Kundenname',
    regNumber: 'Kennzeichen',
    complaint: 'Beschwerde',
    createOrderBtn: 'Bestellung erstellen',
    activeOrders: 'Aktive Bestellungen',

    addWorktime: 'Arbeitszeit hinzufügen',
    worktimeTitle: 'Tätigkeitsname',
    hours: 'Arbeitszeit (Stunden)',
    addWorktimeBtn: 'Arbeitszeit hinzufügen',
    standardWorktimes: 'Standardarbeitszeiten',
    componentFieldLabel: 'Komponente',
    worktimeActivityLabel: 'Tätigkeitsname',
    worktimeHoursLabel: 'Arbeitszeit (Stunden)',
    worktimeDescription: 'Standardzeit für die Ausführung der Tätigkeit',
    noWorktimesSelectedComponent: 'Keine Arbeitszeiten für die ausgewählte Komponente',
    addFirstWorktimeForComponent: 'Fügen Sie die erste Arbeitszeit für diese Komponente hinzu',
    hoursShortSuffix: 'Std.',
    worktimeComponentCabin: 'Kabine',
    worktimeComponentChassis: 'Chassis',
    worktimeComponentFrontAxle: 'Vorderachse',
    worktimeComponentRearAxle: 'Hinterachse',
    worktimeComponentEngine: 'Motor',
    worktimeComponentTransmission: 'Getriebe',

    clientsList: 'Kundenliste',
    trucksLabel: 'LKW',
    trailersLabel: 'Anhänger',
    more: 'mehr',
    editClientTitle: 'Kunde bearbeiten',
    addVehicleToClient: 'Fahrzeug hinzufügen zu',
    addVehicle: 'Fahrzeug hinzufügen',
    deleteClientConfirm: 'Möchten Sie diesen Kunden wirklich löschen?',
    deleteClientError: 'Fehler beim Löschen des Kunden',
    editClientError: 'Fehler beim Bearbeiten des Kunden',
    noClientsFound: 'Keine Kunden gefunden',
    addFirstClientOrChangeSearch: 'Fügen Sie den ersten Kunden hinzu oder ändern Sie die Suche',
    city: 'Stadt',
    vatNumber: 'USt-IdNr.',
    mol: 'Ansprechpartner',
    vehiclesOfClient: 'Fahrzeuge von',
    noRegisteredVehicles: 'Keine registrierten Fahrzeuge',
    requiredFieldsVehicle: 'Bitte Pflichtfelder ausfüllen: Kennzeichen, Marke, Modell',
    addVehicleError: 'Fehler beim Hinzufügen des Fahrzeugs',
    regNumberRequired: 'Kennzeichen *',
    vinNumber: 'VIN',
    brandRequired: 'Marke *',
    modelRequired: 'Modell *',
    vehicleTypeRequired: 'Fahrzeugtyp *',
    yearLabel: 'Jahr',
    gearBox: 'Getriebe',
    gearBoxPlaceholder: 'z. B. PowerShift, TipMatic',
    axesCount: 'Anzahl der Achsen',
    axesPlaceholder: 'z. B. 2 oder 3',

    adminUsersHeading: 'Benutzerverwaltung',
    adminInfoText: 'Verwalten Sie Benutzer, Rollen und Zugriffsrechte für die Module.',
    invoiceSettingsHeading: 'Rechnungs-Einstellungen (Lieferant)',
    invoiceSettingsHint: 'Diese Daten werden beim Drucken von Protokoll/Rechnung im Tab „RECHNUNGEN“ verwendet.',
    brandingSection: 'Branding (obere Leiste)',
    appNameInBar: 'App-Name (Leiste)',
    loginTaglineLine1: 'Slogan (Zeile 1) (Login/Register)',
    loginTaglineLine2: 'Slogan (Zeile 2) (Login/Register)',
    loginTaglineHelp: 'Leer lassen, um den Standard-Slogan auf der Login-Seite zu verwenden.',
    fontInBar: 'Schriftart (Leiste)',
    fontSizeInBar: 'Größe (Leiste)',
    sizeSmall: 'Klein',
    sizeMedium: 'Mittel',
    sizeLarge: 'Groß',
    sizeVeryLarge: 'Sehr groß',
    showBrandingLoginRegister: 'Branding auf Login/Register anzeigen',
    loginGradient: 'Verlauf (Login/Register)',
    paymentMethod: 'Zahlungsart',
    bank: 'Bank',
    hourlyRate: 'Stundensatz',
    vatRate: 'MwSt.',
    invoiceNumbering: 'Nummerierung (Protokoll / Rechnung)',
    invoiceNumberingHint: 'Geben Sie die zuletzt vergebenen Nummern ein. Das System verwendet die nächste Nummer (+1).',
    invoicePrefix: 'Rechnungspräfix',
    invoiceLength: 'Länge (Rechnung)',
    invoiceLastNo: 'Letzte Nr. (Rechnung)',
    protocolLength: 'Länge (Protokoll)',
    protocolLastNo: 'Letzte Nr. (Protokoll)',
    logoForDocs: 'Logo (Protokoll/Rechnung)',
    chooseFile: 'Datei wählen',
    remove: 'Entfernen',
    logoRecommendation: 'Empfehlung: quadratisches PNG, transparenter Hintergrund.',
    noLogoUploaded: 'Kein Logo hochgeladen.',
    saveSettings: 'Einstellungen speichern',
    usersRegistered: 'Registrierte Benutzer',
    userCol: 'Benutzer',
    roleCol: 'Rolle',
    statusCol: 'Status',
    registeredCol: 'Registriert',
    lastLoginCol: 'Letzte Anmeldung',
    permissionsCol: 'Berechtigungen',
    actionsCol: 'Aktionen',
    roleUser: 'Benutzer',
    roleAdmin: 'Administrator',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    never: 'Nie',
    modulesCount: 'Module',
    noUsers: 'Keine registrierten Benutzer',
    loadUsersError: 'Fehler beim Laden der Benutzer',
    saveCompanySettingsError: 'Fehler beim Speichern der Einstellungen',
    savePermissionsError: 'Fehler beim Speichern der Berechtigungen',
    changeRoleError: 'Fehler beim Ändern der Rolle',
    changeStatusError: 'Fehler beim Ändern des Status',
    deleteUserConfirm: 'Möchten Sie den Benutzer wirklich löschen',
    userDeleted: 'Benutzer erfolgreich gelöscht',
    deleteUserError: 'Fehler beim Löschen des Benutzers',
    fileTooLarge: 'Datei ist zu groß. Bitte Logo bis ~600KB (PNG/JPG) wählen.',
    fileReadError: 'Fehler beim Lesen der Datei.',

    invitationsManage: 'Einladungen',
    createInvitation: 'Einladung erstellen',
    token: 'Token',
    createdBy: 'Erstellt von',
    status: 'Status',
    createdAt: 'Erstellt',
    expiresAt: 'Läuft ab',
    used: 'Verwendet',
    activeInvitation: 'Aktiv',
    noInvitations: 'Keine Einladungen vorhanden',
    invitationEmailRequired: 'Bitte E-Mail-Adresse eingeben',
    invitationErrorPrefix: 'Fehler beim Erstellen der Einladung: ',
    deleteInvitationConfirm: 'Möchten Sie diese Einladung wirklich löschen?',
    deleteInvitationError: 'Fehler beim Löschen der Einladung',
    linkCopied: 'Link in die Zwischenablage kopiert',
    newInvitationTitle: 'Neue Registrierungseinladung',
    copyInvitationHint: 'Kopieren Sie diesen Link und senden Sie ihn an den Benutzer:',
    linkValidUntil: 'Link gültig bis:',
    copyLink: 'Link kopieren',

    permissionsManage: 'Berechtigungen',
    permissionsHelp: 'Wählen Sie die Aktionen, die der Benutzer in jedem Modul ausführen darf.',
    moduleAccess: 'Modulzugriff:',
    read: 'Lesen',
    write: 'Schreiben',
    deleteAction: 'Löschen',
    savePermissions: 'Berechtigungen speichern',

    // Parts / Consumables module
    parts: 'Teile & Verbrauchsmaterial',
    partsTitle: 'Teile & Verbrauchsmaterial',
    homePartsDesc: 'Lagerbestand von Teilen und Verbrauchsmaterial',
    partsSearch: 'Teile suchen',
    partsSearchPlaceholder: 'Name, Artikel, Kategorie...',
    allCategories: 'Alle Kategorien',
    lowStockOnly: 'Nur niedriger Bestand',
    partName: 'Bezeichnung',
    sku: 'Artikel-Nr.',
    category: 'Kategorie',
    unit: 'Einheit',
    quantity: 'Bestand',
    minQuantity: 'Mindestbestand',
    price: 'Preis',
    location: 'Lagerort',
    addPart: 'Teil hinzufügen',
    editPart: 'Teil bearbeiten',
    partNameRequired: 'Bitte Bezeichnung eingeben',
    adjustStock: 'Bestandsänderung',
    stockIn: 'Zugang',
    stockOut: 'Abgang',
    movementHistory: 'Bewegungshistorie',
    movementType: 'Operationstyp',
    movementQuantity: 'Menge',
    movementDate: 'Datum',
    movementBy: 'Von',
    supplier: 'Lieferant',
    currentStock: 'Aktueller Bestand',
    quantityPositive: 'Die Menge muss eine positive Zahl sein',
    noPartsFound: 'Keine Teile gefunden',
    noMovements: 'Keine Bewegungen für dieses Teil',
    inStock: 'Auf Lager',
    lowStock: 'Niedriger Bestand',
    outOfStock: 'Kein Bestand',
    deletePartConfirm: 'Möchten Sie dieses Teil wirklich löschen?',
    quantityEditHint: 'Der Bestand kann nur über eine Bestandsänderung (Zugang/Abgang) geändert werden.',
    partsLoadError: 'Fehler beim Laden der Teile',
    partsSaveError: 'Fehler beim Speichern des Teils',
    partsDeleteError: 'Fehler beim Löschen des Teils',
    partsAdjustError: 'Fehler bei der Bestandsänderung',
    loading: 'Laden...',

  },

  // Empty objects => fallback to English
  fr: {},
  es: {},
  it: {},
  ru: {},
  tr: {},
};

export const getStoredLanguage = () => {
  try {
    if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
    return localStorage.getItem('language') || DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

export const t = (key, lang = getStoredLanguage()) => {
  return (
    TRANSLATIONS?.[lang]?.[key] ??
    TRANSLATIONS?.[FALLBACK_LANGUAGE]?.[key] ??
    TRANSLATIONS?.[DEFAULT_LANGUAGE]?.[key] ??
    key
  );
};

